import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Loader from "../Loader";
import { commonStyles } from "../commonStyles";

// Shared loading states (Phase A promotion, module 11 polish pass). Donors:
// - Table loading row: ManageMembers/ManageInvoices/ManageEvents colSpan cell
//   with gold CircularProgress + "Loading ..." label.
// - Full page: FullPageLoader (100vh flex-center) wrapping common/Loader —
//   the gold spinner is reused via Loader, never forked.

export type LoadingOverlayProps = {
  /** e.g. "Loading members..."; omitted -> spinner only */
  label?: string;
  /** Table-row mode: renders <TableRow><TableCell colSpan> wrapper (MUI) */
  colSpan?: number;
  /** 100vh centered (FullPageLoader look); mutually exclusive with colSpan */
  fullPage?: boolean;
  /** CircularProgress size for row/inline mode, default 20 */
  size?: number;
};

const rowContentClassName =
  "flex items-center justify-center gap-3 py-8 text-sm font-semibold text-gray-500";

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  label,
  colSpan,
  fullPage = false,
  size = 20,
}) => {
  if (fullPage) {
    return (
      <div className="flex h-screen items-center justify-center gap-3 text-sm font-semibold text-gray-500">
        <Loader />
        {label ? <span>{label}</span> : null}
      </div>
    );
  }

  const content = (
    <div className={rowContentClassName}>
      <CircularProgress size={size} sx={{ color: commonStyles.cpaGold }} />
      {label ? <span>{label}</span> : null}
    </div>
  );

  if (colSpan !== undefined) {
    return (
      <TableRow>
        <TableCell colSpan={colSpan}>{content}</TableCell>
      </TableRow>
    );
  }

  return content;
};
